import { Job } from '~extension/web2print/model/Job';
import { DownloadFormatListItem } from '~extension/web2print/view/Download/DownloadFormatListItem';

type DownloadFormatListProps = {
  downloadJob: Job;
};

export function DownloadFormatList({ downloadJob }: DownloadFormatListProps) {
  return (
    <>
      {Object.values(downloadJob.downloadFormats).map((downloadFormat, index) => (
        <DownloadFormatListItem
          jobId={downloadJob.jobId}
          documentId={downloadJob.documentId}
          clientId={downloadJob.clientId}
          downloadFormat={downloadFormat}
          key={index}
        />
      ))}
    </>
  );
}
